/* -----------------Child components--------------- */
import AccountListItem from "./AccountListItem";

import type { FontSchemaType } from "../../font";
import { useDevice } from "../../useDevice";
/* -----------------Types--------------- */
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { CustomListSubheader } from "../CustomListSubheader";
import ScrollContainer from "../ScrollContainer";
import type { Section } from "./types";

type Props = {
	sections: Section[];
	showPoweredBy?: boolean;
	font: FontSchemaType;
	isDarkMode: boolean;
	showAudioPlaybackTestDialog: boolean;
	adminPaywallEnabled?: boolean;
	accountExtendValidity: string;
	hasMoreThanOneExam?: boolean;
	toggleDarkMode: () => void;
	PoweredBy?: () => React.ReactNode;
	toggleAudioPlaybackTestDialog: () => void;
	toggleAdminPaywall?: () => void;
	handleNavigateToExamsRoute: () => void;
};

const AccountSettingsApplet = ({
	sections,
	showPoweredBy,
	font,
	isDarkMode,
	showAudioPlaybackTestDialog,
	adminPaywallEnabled,
	accountExtendValidity,
	hasMoreThanOneExam,
	toggleDarkMode,
	toggleAudioPlaybackTestDialog,
	toggleAdminPaywall,
	PoweredBy,
	handleNavigateToExamsRoute,
}: Props) => {
	const { isMobile } = useDevice();

	return (
		<>
			<ScrollContainer maxWidth="sm">
				<FlatCard
					style={{
						marginTop: isMobile ? 0 : 16,
						marginBottom: 16,
					}}
				>
					<Box gap={16} paddingTop={16}>
						{sections.map(({ sectionTitle, items }) => (
							<Box key={sectionTitle} gap={8}>
								<CustomListSubheader
									style={{
										paddingLeft: 16,
									}}
									font={font}
								>
									{sectionTitle}
								</CustomListSubheader>
								{items.map((view) => (
									<AccountListItem
										key={view.title}
										{...view}
										isDarkMode={isDarkMode}
										showAudioPlaybackTestDialog={showAudioPlaybackTestDialog}
										adminPaywallEnabled={adminPaywallEnabled}
										accountExtendValidity={accountExtendValidity}
										hasMoreThanOneExam={hasMoreThanOneExam}
										toggleDarkMode={toggleDarkMode}
										toggleAudioPlaybackTestDialog={
											toggleAudioPlaybackTestDialog
										}
										toggleAdminPaywall={toggleAdminPaywall}
										handleNavigateToExamsRoute={handleNavigateToExamsRoute}
									/>
								))}
							</Box>
						))}
					</Box>
					{showPoweredBy && PoweredBy && <PoweredBy />}
				</FlatCard>
			</ScrollContainer>
		</>
	);
};

export default AccountSettingsApplet;
